import { useContext, useState, useEffect, useRef } from "react";
import PageContext from "./PageContext.jsx";
import { HttpContext } from "../../api-services/HttpService.js";
import CCOffcanvas from "./CCOffcanvas.tsx";
import ButtonComponent from "./ButtonComponent.jsx";
import "../../css/offcanvasStyle.css";
import RebateTrailRow from "./RebateTrailRow";
import OrderedDataTable from "./OrderedDataTableCopy.jsx";
import isNullOrUndefined from '../functions/isNullOrUndefined'; 
import StandardRow from './StandardRowFormatted'; 
import EllipsisInfoLabel from "./EllipsisInfoLabel.jsx";

const RebateTrailModal = () => {
    // get context variables from parent 
    const { 
      trailModal, 
      setTrailModal,
      editRow
  } = useContext(PageContext);
  // initialize http context 
  const {
      GET, 
  } = useContext(HttpContext);
  // intialize state to display
  const [trailDataList, setTrailDataList] = useState([]);
  const [trailTableHeaders, setTrailTableHeaders] = useState([]);
  const [auditTrailDataList, setAuditTrailDataList] = useState([]);
  const [auditTrailTableHeaders, setAuditTrailTableHeaders] = useState([]);
  const [incentiveFrequency, setIncentiveFrequency] = useState('');
  // initialize spinner state
  const [showSpinner, setShowSpinner] = useState(false);
  // initialize state for rate format
  const [rebateInputTypeId, setRebateInputTypeId] = useState(0); 
  // ref to determine initial render
  const initialRender = useRef(true); 

  //function to call api to get rebate workflow trail. takes in a workflowid
  const getWorkflowTrail = () => {
      setShowSpinner(showSpinner => showSpinner = true);
      return new Promise((resolve, reject) => {
          console.log('EDITROW: ', editRow); 
          GET('/workflow/trail', { 
              workflowid: editRow['workflowid'], 
              workflowtypeid: editRow['workflowtypeid']
          }).then(res => {
              console.log(res['data']);
              // set state
              setAuditTrailDataList(auditTrailDataList => auditTrailDataList = res['data']['AuditTrailData']);
              setAuditTrailTableHeaders(auditTrailTableHeaders => auditTrailTableHeaders =  res['data']['AuditTrailCols']);
              setTrailDataList(trailData => trailData = res['data']['AggregateData']);
              setTrailTableHeaders(trailTableHeaders => trailTableHeaders = res['data']['AggregateCols']);   
              setRebateInputTypeId(rebateInputTypeId => rebateInputTypeId = res['data']['RebateInputTypeId']);          
              // hide spinner
              setShowSpinner(showSpinner => showSpinner = false);
              resolve(res);
          }).catch(err => {
              // hide spinner
              setShowSpinner(showSpinner => showSpinner = false);
              reject(err);
          });
      });
  }

  const TrailRowComponent = (row, count, tableHeader,stickyEnabled) => {
      return <RebateTrailRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled}/>;
  }

  const AggregateRowComponent =(row, count, tableHeader,stickyEnabled) => {
      return <StandardRow row={row} count={count} tableHeader={tableHeader} rateTypeId={rebateInputTypeId} stickyEnabled={stickyEnabled}/>; 
  }

  // update company info every time row changes
  useEffect(()=>{
      if (!initialRender.current){
          // set incentive frequency 
          if (!isNullOrUndefined(editRow['workflowtypeid']) && editRow['workflowtypeid'] === process.env.REACT_APP_REBATE_WORKFLOW_TYPE_ID){
              setIncentiveFrequency(incentiveFrequency => incentiveFrequency = '[' + editRow.incentivefreq + ']'); 
          }
          else {
              setIncentiveFrequency(incentiveFrequency => incentiveFrequency = ''); 
          }            
          // get table data 
          getWorkflowTrail().then(res => {
              console.log(res); 
          }).catch(err => {
              console.log(err); 
          });
      }
      else {
          initialRender.current = false; 
      }
      
  }, [editRow.workflowid]);

  const settings = {
      rebateInputTypeId, 
  }; 

  return (
    <CCOffcanvas
      title={"Audit Trail"}
      show={trailModal}
      onCanvasClose={() => setTrailModal(false)}
      bodyCssClassName="offcanvas-body"
      offCanvasClassName="offcanvas-parent-card"
    >
      <div className="d-flex flex-column h-100">
      {/* read only input for info on rebate workflow that is being viewed */}
        <div className="bg-white p-3" style={{ fontSize: "14px" }}>
          <div className="d-flex gap-3 flex-wrap"> 
            <EllipsisInfoLabel title={'Company Name:'} content={editRow.mastercompanyname} maxChar='50'/>
            <div className="vr"></div>
            <EllipsisInfoLabel title={'Workflow type: '} content={editRow['workflowtypedescription']} maxChar='20'/>
            <div className="vr"></div>
            <EllipsisInfoLabel title={'Payout Cycle:'} content={editRow.periodcyclestart + '-' + editRow.periodcycleend + ' ' + incentiveFrequency} maxChar='50'/>
          </div>
        </div>
        <div className="d-flex flex-column flex-grow-1 overflow-scroll">
          <div className="p-3 trail-section">
            <div className="bg-white trail-card">
              <OrderedDataTable
                RowComponent={AggregateRowComponent}
                tableHeader={trailTableHeaders}
                dataList={trailDataList}
                showSpinner={showSpinner}
                disableMaxTableHeight={true}
                stickyFirstColumnEnabled={true}
              />
            </div>
          </div>
          <div className="p-3 trail-section">
            <div className="bg-white trail-card">
              <OrderedDataTable
                RowComponent={TrailRowComponent}
                tableHeader={auditTrailTableHeaders}
                dataList={auditTrailDataList}
                showSpinner={showSpinner}
                disableMaxTableHeight={true}
              />
            </div>
          </div>
          
        </div>
        <div className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}>
          <ButtonComponent
            tag={"OK"}
            border={'#fcd800 1px solid'}
            background={'#fcd800'}
            color={'#001317'}
            onButtonClick={() =>
              setTrailModal((trailModal) => (trailModal = false))
            }
          />
        </div>
      </div>
    </CCOffcanvas>
  );
};

export default RebateTrailModal;
